import { render } from "./ExtraInfo.vue?vue&type=template&id=5cc2bfbd&scoped=true"
import script from "./ExtraInfo.vue?vue&type=script&lang=js"
export * from "./ExtraInfo.vue?vue&type=script&lang=js"

import "./ExtraInfo.vue?vue&type=style&index=0&id=5cc2bfbd&scoped=true&lang=css"

import exportComponent from "C:\\code\\kascenskaforvt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc2bfbd"]])

export default __exports__